import { lazy } from 'react';
import Home from '../pages/home/page';
import NotFound from '../pages/NotFound';

// Lazy load das páginas não-críticas
const Cart = lazy(() => import('../pages/cart/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const Auth = lazy(() => import('../pages/auth/page'));
const Profile = lazy(() => import('../pages/profile/page'));

const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/cart',
    element: <Cart />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/auth',
    element: <Auth />,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
